export default "__VITE_ASSET__c362f76e__"